import { defineMessages } from 'react-intl';

export default defineMessages({
    effectiveDate: {
        id: 'twia.policychange.views.contact-details.PolicyChangeEffectiveDate',
        defaultMessage: 'Policy Change Effective Date',
    },
});
